
import { defineComponent } from "vue";
import type { IAcademicPerformanceGradesModel } from "@/interfaces/modules";
import AcademicPerformanceGradesService from "@/api/AcademicBase/AcademicPerformanceGradesService";
import StudentService from "@/api/Aula/StudentsService";
import TeacherService from "@/api/Aula/TeachersService";
import PeriodService from "@/api/Configuration/PeriodsService";
import store from "@/store";

export default defineComponent({
  name: "AcademicPerformanceGradesContent",
  data() {
    return {
      students: [] as any[],
      teachers: [] as any[],
      periods: [] as any[],
      performances: [] as any[],
      form: {
        dialog: false,
        record: {} as Partial<IAcademicPerformanceGradesModel>,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "StudentId", label: "Estudiante", sortable: true },
          { key: "PerformanceId", label: "Desempeño", sortable: true },
          { key: "Score", label: "Calificación", sortable: true },
          { key: "GradedByTeacherId", label: "Docente", sortable: true },
          { key: "GradedAt", label: "Fecha", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IAcademicPerformanceGradesModel[],
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredItems(): IAcademicPerformanceGradesModel[] {
      const search = this.table.filters.search?.toLowerCase() ?? "";
      if (!search) return this.table.records;
      return this.table.records.filter(
        (item) =>
          item.Score?.toString().includes(search) ||
          item.GradedAt?.toLowerCase().includes(search)
      );
    },
    rows(): number {
      return this.table.records.length;
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      try {
        this.table.records = await AcademicPerformanceGradesService.GetPerformances();
        this.students = await StudentService.GetStudents();
        this.teachers = await TeacherService.GetTeachers();
        this.periods = await PeriodService.GetPeriods();
      } finally {
        this.table.loading = false;
      }
    },
    async edit(item: IAcademicPerformanceGradesModel) {
      this.form.record = await AcademicPerformanceGradesService.GetPerformanceById(item);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Id: 0 } as Partial<IAcademicPerformanceGradesModel>;
      this.form.dialog = true;
    },
    async handleSubmit() {
      const payload = {
        Id: this.form.record.Id ?? 0,
        StudentId: this.form.record.StudentId ?? 0,
        PeriodId: this.form.record.PeriodId ?? 0,
        PerformanceId: this.form.record.PerformanceId ?? 0,
        Score: this.form.record.Score ?? 0,
        GradedByTeacherId: this.form.record.GradedByTeacherId ?? 0,
        GradedAt: this.form.record.GradedAt ?? new Date().toISOString(),
      } as IAcademicPerformanceGradesModel;

      this.form.dialog = false;
      await AcademicPerformanceGradesService.PostPerformance(payload);

      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });

      this.load();
    },
  },
});
